import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button, IconButton, withStyles } from "@material-ui/core";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { resizeImageByPercentage } from "utils/Utils";
import { Slider } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { saveAadharTransaction } from "store/reducers/LoanApplication/LoanApplicationSlice";
import { useDispatch, useSelector } from "react-redux";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import ToastModal from "views/components/ToastModal";
import { useDigioLiveness } from "./DigioSdk";
import { documentCasesNames } from "assets/properties/properties";

const DigioCameraComponent = ({
  classes,
  label,
  loanApplicationId,
  customerImage,
  faceLineNessVendor,
  imageIcon,
  type,
  UploadCameraFile,
  setDisabledSubmit,
  featureFlags,
  mobileNumber,
  logo,
  customerName
}) => {
  const [callInProgress, setCallInProgress] = useState(false);
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.login.authData);
  const [showCamera, setShowCamera] = useState(false);
  const [customerImageUri, setCustomerImageUri] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [digioImage, setDigioImage]=useState("")
const { startLiveness } = useDigioLiveness({
  customerName: customerName || "DIGIO LIVENESS",
  mobileNumber,
  logo,
  templateName: featureFlags?.digioTemplateName || "faceLiveliness",
  setDigioImage,
  setCallInProgress,
  digioEnvironment: featureFlags?.digioEnvironment || "production",
});
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
const  base64ToBlob= (base64, contentType = "image/jpeg")=> {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
}

const blobToFile = (blob, fileName) =>{
  return new File([blob], fileName, { type: blob.type });
}
  useEffect(()=>{
    if(digioImage){
    const blob = base64ToBlob(digioImage?.file_in_base64, "image/jpeg");
    const file = blobToFile(blob, "image.jpeg");
    const imageUrl = URL.createObjectURL(blob);
    setCustomerImageUri(imageUrl);

    UploadCameraFile(file,documentCasesNames?.customer);

    }
  },[digioImage])
  const enabledCamera = async () => {
    // setShowCamera(true);
    startLiveness();
  };
  return (
    <div>
      <GridContainer style={{ marginTop: 0 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            {!showCamera &&
            <GridContainer onClick={enabledCamera} role="button">
              <GridItem
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  width: "300px",
                  height: "300px",
                  border: "1px solid #ccc",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {customerImageUri || customerImage ? (
                  <div className={classes.imageWrapper}>
                    <img
                      src={customerImageUri || customerImage}
                      alt="Captured"
                      style={{
                        width: "300px",
                        height: "300px",
                        objectFit: "cover",
                        transition: "opacity 0.3s ease",
                      }}
                    />
                    <div className={classes.overlay}>Edit</div>
                  </div>
                ) : (
                  <img
                    src={imageIcon}
                    alt="Upload Placeholder"
                    style={{
                      width: "86%",
                      height: "81%",
                      objectFit: "cover",
                    }}
                  />
                )}
              </GridItem>
            </GridContainer>
            }
          </GridItem>
        </GridItem>
      </GridContainer>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </div>
  );
};

DigioCameraComponent.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  closeModal: PropTypes.func,
};

export default DigioCameraComponent;
